import { useMutation, useQueryClient } from '@tanstack/react-query';
import { formatCount, formatTaka } from '@/utils/number';
import { disbursePcmpRedisburseBatch } from '../api/pcmpAccounts.api';
import type {
  PcmpAccountsDisbursePayload,
  PcmpAccountsDisburseResult,
} from '../types/pcmpAccounts.types';
import { pcmpActionCallbacks } from '../utils/pcmpActionCallbacks';

export function useDisbursePcmpRedisburseBatch(
  batchNo: number,
  onSuccess: (result: PcmpAccountsDisburseResult) => void,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PcmpAccountsDisbursePayload) =>
      disbursePcmpRedisburseBatch(batchNo, payload),
    ...pcmpActionCallbacks<PcmpAccountsDisburseResult>(
      queryClient,
      (result) =>
        `${formatCount(result.disbursed.length, 'proposal')} re-disbursed (${formatTaka(
          result.disbursedAmount,
        )})`,
      onSuccess,
    ),
  });
}
